var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.11111 2.66759L24 2.66847M8.11111 10.001L24 10.0019M8.11111 17.3343L24 17.3353M2.61111 2.66678H2.62333M2.61111 10.0001H2.62333M2.61111 17.3334H2.62333M3.22222 2.66678C3.22222 3.00428 2.94862 3.27789 2.61111 3.27789C2.27361 3.27789 2 3.00428 2 2.66678C2 2.32927 2.27361 2.05566 2.61111 2.05566C2.94862 2.05566 3.22222 2.32927 3.22222 2.66678ZM3.22222 10.0001C3.22222 10.3376 2.94862 10.6112 2.61111 10.6112C2.27361 10.6112 2 10.3376 2 10.0001C2 9.66265 2.27361 9.389 2.61111 9.389C2.94862 9.389 3.22222 9.66265 3.22222 10.0001ZM3.22222 17.3334C3.22222 17.6709 2.94862 17.9446 2.61111 17.9446C2.27361 17.9446 2 17.6709 2 17.3334C2 16.996 2.27361 16.7223 2.61111 16.7223C2.94862 16.7223 3.22222 16.996 3.22222 17.3334Z",
    stroke: "#3E3E3E",
    strokeWidth: 2.44444,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.e43158a0ddf4e30a6910416384941df0.svg";
export { ForwardRef as ReactComponent };